// Translate
import { createI18n } from 'vue-i18n'
import en from './en.json'
import pt_br from './pt_br.json'


const i18n = createI18n({
      locale: 'pt_br',
      fallbackLocale: 'en',
      silentFallbackWarn: true,
      messages: {
            en: en,
            pt_br: pt_br,
      },
      missing: () => {
            return '';
      }
})


export default i18n;